import Marquee from "react-fast-marquee";

const ITEMS = [
  "Family Law",
  "Real Estate Law",
  "Probate",
  "Estate Planning",
  "Jamaica & the Diaspora",
];

const EditorialMarquee = ({ dark = true }) => (
  <div
    data-testid="editorial-marquee"
    className={`py-5 border-y ${
      dark
        ? "bg-navy text-cream border-navy"
        : "bg-sand text-navy border-navy/10"
    } overflow-hidden`}
    aria-hidden="true"
  >
    <Marquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.concat(ITEMS).map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-xl md:text-2xl font-light px-8 whitespace-nowrap">
            {item}
          </span>
          <span className="text-gold text-xs">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
